import styled from 'styled-components';

import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { ReactComponent as CloseIcon } from '@mo-assets/icon/icon__close.svg';

const Container = styled.div`
  position: absolute;
  bottom: 65px;
  display: flex;
  width: 100%;
  height: 176px;
  padding: 21px 22px 31px 22px;
  border-radius: 10px 10px 0 0;
  background: ${(props) => props.theme.color.background.basic};
`;

const WelcomeText = styled(TextBox)`
  width: 100%;
  margin-left: 3px;
`;

const InfoContainer = styled(FlexBoxColumn)`
  width: 100%;
  height: 90px;
  padding: 20px 22px;
  border-radius: 10px;
  gap: 10px;
  background: white;
`;

const InfoTextBox = styled(FlexBox)`
  width: 100%;
  justify-content: space-between;
`;

const CloseButton = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  top: -13px;
  right: -14px;
`;

const ShowMileageButton = styled.div`
  width: 80px;
  height: 24px;
  border: 1px solid ${(props) => props.theme.color.primary};
  border-radius: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
`;

export { Container, WelcomeText, InfoContainer, InfoTextBox, CloseButton, ShowMileageButton };
